async function parseResponseBody(response) {
    const text = await response.text();
    if (!text) return null;
    try {
        return JSON.parse(text);
    } catch {
        return { message: text };
    }
}

async function Fetch(link, method, data = null) {
    const isLogin = String(link).includes('/login');
    const token = localStorage.getItem('token');

    const headers = {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    let body = data;
    if (data !== null && data !== undefined) {
        if (data instanceof FormData) {
            body = data;
        } else {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(data);
        }
    }

    try {
        const response = await fetch(link, { method, headers, body });
        const status = response.status;
        const json = await parseResponseBody(response);

        if (status === 401 && !isLogin && token) {
            localStorage.removeItem('token');
            localStorage.removeItem('id');
            if (!window.location.pathname.includes('/login')) {
                window.location.assign('/login');
            }
        }

        return { status, data: json };
    } catch (err) {
        return {
            status: 0,
            data: {
                message: err?.message || 'Network error',
                errors: [err?.message || 'Network error'],
            },
        };
    }
}

export default Fetch;
